import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useVuetify } from '@/composables/useVuetify'
import { imageURL } from '@/assets/images/url/imageURL'

// COMPOSABLES

export default /*#__PURE__*/_defineComponent({
  __name: 'LefebvreLogoComponent',
  setup(__props) {

const { isMobileBreakpoint } = useVuetify()

// COMPUTED
const logo = computed(() => {
  if (isMobileBreakpoint.value) {
    return imageURL.isotype
  } else {
    return imageURL.logo
  }
})

return { __sfc: true,isMobileBreakpoint, logo }
}

})